/* Lily-style product-card swatches for Wealth Kings tiles.
   Hover a color swatch -> swap the card's primary image to that color's
   variant photo (preloaded first, so there is no blank flash).
   Click a swatch -> go straight to that variant.
   Delegated listeners so it works for lazy-loaded / paginated grids. */
(function () {
  if (window.__tileSwatchBooted) return;
  window.__tileSwatchBooted = true;

  function primaryImg(container) {
    var card = container.closest('.product-tile');
    return card ? card.querySelector('.product-tile__image--primary') : null;
  }
  function secondaryImg(sw) {
    var card = sw.closest('.product-tile');
    return card ? card.querySelector('.product-tile__image--secondary') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest('.product-tile__swatch');
    if (!sw) return;
    var container = sw.closest('[data-tile-swatches]');
    if (!container) return;
    var img = primaryImg(container);
    if (!img) return;
    var src = sw.getAttribute('data-swatch-src');
    if (!src) return;

    if (!img.dataset.origSrc) {
      img.dataset.origSrc = img.currentSrc || img.src;
      img.dataset.origSrcset = img.getAttribute('srcset') || '';
    }

    var token = String(Date.now()) + ':' + Math.round(window.performance ? performance.now() : 0);
    img.dataset.swapToken = token;

    /* The card's own :hover CSS fades the primary image to opacity:0 (crossfade to
       secondary). Force the primary visible so our swapped color image shows, and
       hide the secondary so it doesn't crossfade over it. */
    img.style.opacity = '1';
    var sec = secondaryImg(sw);
    if (sec) sec.style.opacity = '0';

    var pre = new Image();
    pre.onload = function () {
      if (img.dataset.swapToken !== token) return; /* a newer hover won */
      /* drop srcset so the browser shows exactly this preloaded src (no re-pick / no flash) */
      img.removeAttribute('srcset');
      img.src = src;
    };
    pre.src = src;
  });

  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest('.product-tile__swatch');
    if (!sw) return;
    var container = sw.closest('[data-tile-swatches]');
    if (!container) return;
    if (e.relatedTarget && container.contains(e.relatedTarget)) return; /* still inside swatches */
    var img = primaryImg(container);
    if (!img || !img.dataset.origSrc) return;

    img.dataset.swapToken = ''; /* cancel any pending preload swap */
    img.src = img.dataset.origSrc;
    if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
    else img.removeAttribute('srcset');

    var sec = secondaryImg(sw);
    if (sec) sec.style.opacity = '';
  });

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.product-tile__swatch');
    if (!sw) return;
    var url = sw.getAttribute('data-swatch-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  });
})();
